
















import 'vue-area-linkage/dist/index.css';
import { pcaa } from 'area-data';
import { AreaSelect } from 'vue-area-linkage';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'lb-area',
  components: {
    AreaSelect,
  },
})
export default class extends Vue {
  @Prop({ required: true, default: () => []}) private value!: any[];
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ default: 'medium', validator(value) { return ['large', 'medium', 'small'].indexOf(value) > -1; }}) private size!: string;
  @Prop({ default: 2 }) private level!: number;
  @Prop({ default: 'text', validator(value) { return ['all', 'code', 'text'].indexOf(value) > -1; }}) private type!: string;
  @Prop({ default: () => ['省', '市', '区'] }) private placeholder!: string[];

  private areaData = pcaa;

  private localArea = this.value;

  private handleChange(area: any[]) {
    this.$emit('change', area);
  }

  @Watch('value')
  private onValueChange(val: any[]) {
    this.localArea = val;
  }

  @Watch('localArea')
  private onLocalAreaChange(val: any[]) {
    this.$emit('input', val);
  }
}
